var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCases = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42586E",
    fillRule: "evenodd",
    d: "M20 20.825H5c-1.378 0-2.5-1.091-2.5-2.432V6.257c0-1.341 1.122-2.432 2.5-2.432h4.601c.299 0 .584.135.774.367l2.599 3.179H20c1.378 0 2.5 1.09 2.5 2.432v8.59c0 1.34-1.122 2.432-2.5 2.432",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCases, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cases.3c518171.svg";
export { ForwardRef as ReactComponent };